import { DispatchDashboard, ShipmentsDashboard } from "@svan-garaaz/lmd";
import { withApiConfig } from "../hoc/withApiConfig";

const r2dFilters = {
  orderStatus: ["READY_TO_DISPATCH"],
  shippedOrders: "false",
  isPopulated: "true",
  limit: "1",
};

const dispatchedFilters = {
  orderStatus: ["DISPATCHED"],
  shippedOrders: "false",
  isPopulated: "true",
  limit: "1",
};

const r2dOrderFilters = {
  orderStatus: ["READY_TO_DISPATCH"],
  shippedOrders: "false",
  isPopulated: "true",
  limit: "50",
};

const dispatchedOrderFilters = {
  orderStatus: ["DISPATCHED"],
  shippedOrders: "false",
  isPopulated: "true",
  limit: "50",
};

/** Keys for both current LMD DispatchDashboard and legacy R2D naming. */
const r2dCustomFilters = {
  getDispatchCustomerFacets: {
    filters: { ...r2dFilters, facets: "customers" },
  },
  getDispatchSupplierFacets: {
    filters: { ...r2dFilters, facets: "suppliers" },
  },
  getDispatchOrdersForSupplier: {
    filters: r2dOrderFilters,
  },
  getR2DCustomerFacets: {
    filters: { ...r2dFilters, facets: "customers" },
  },
  getR2DSupplierFacets: {
    filters: { ...r2dFilters, facets: "suppliers" },
  },
  getR2DOrdersForSupplier: {
    filters: r2dOrderFilters,
  },
};

const dispatchedCustomFilters = {
  getDispatchCustomerFacets: {
    filters: { ...dispatchedFilters, facets: "customers" },
  },
  getDispatchSupplierFacets: {
    filters: { ...dispatchedFilters, facets: "suppliers" },
  },
  getDispatchRiderFacets: {
    filters: { ...dispatchedFilters, facets: "riders" },
  },
  getDispatchOrdersForSupplier: {
    filters: dispatchedOrderFilters,
  },
  getR2DCustomerFacets: {
    filters: { ...dispatchedFilters, facets: "customers" },
  },
  getR2DSupplierFacets: {
    filters: { ...dispatchedFilters, facets: "suppliers" },
  },
  getR2DOrdersForSupplier: {
    filters: dispatchedOrderFilters,
  },
};

const R2DOrdersWithEmptyRiders = withApiConfig(DispatchDashboard, {
  maskDeliveryContactDetails: true,
  userName: "Garaaz",
  enableDistanceTabs: true,
  dashboardMode: "r2d",
  dashboardTitle: "R2D Dashboard",
  customFilters: r2dCustomFilters,
  refreshConfig: {
    enabled: true,
    intervalMinutes: 10,
  },
});

const DispatchedOrdersWithEmptyRiders = withApiConfig(DispatchDashboard, {
  maskDeliveryContactDetails: true,
  userName: "Garaaz",
  enableDistanceTabs: true,
  dashboardMode: "dispatched",
  dashboardTitle: "Dispatch Dashboard",
  customFilters: dispatchedCustomFilters,
  refreshConfig: {
    enabled: true,
    intervalMinutes: 10,
  },
});

export const ApiAwareR2DOrders = R2DOrdersWithEmptyRiders;
export const ApiAwareDispatchedOrders = DispatchedOrdersWithEmptyRiders;
export const ApiAwareShipmentsDashboard = withApiConfig(ShipmentsDashboard);
